<template>
    <div class="flex-grow-1 d-flex">
        <div class="action-buttons d-none d-md-flex">
            <template v-for="(actionButton) in actionButtons">
                <b-button
                      v-if="actionButton.condition()"
                      :variant="actionButton.variant"
                      :class="actionButton.buttonClass"
                      @click="actionButton.onClick"
                    >
                    {{ actionButton.text }}
                    <font-awesome-icon
                          v-if="actionButton.icon"
                          :icon="actionButton.icon"
                        class="ml-2"
                    >
                    </font-awesome-icon>
                </b-button>
            </template>
        </div>

        <b-dropdown
            dropup
            no-caret
            variant="outline-primary"
            text="Actions"
            class="d-md-none align-self-end ml-auto"
        >
            <template slot="button-content">
                Actions
            <font-awesome-icon
                        class="ml-1"
                        :icon="['fal', 'chevron-up']"
                ></font-awesome-icon>
            </template>
            <template v-for="(actionButton, index) in actionButtons">
                <b-dropdown-item
                      v-if="actionButton.condition()"
                      :class="actionButton.buttonClass"
                      @click="actionButton.onClick"
                    >
                    <font-awesome-icon
                              v-if="actionButton.icon"
                              :icon="actionButton.icon"
                              class="mr-2"
                            >
                    </font-awesome-icon>
                  {{ actionButton.text }}
                </b-dropdown-item>
            </template>
        </b-dropdown>

        <div class="modals">
            <note-modal
                :title="noteTitle"
                :show.sync="showNoteModal"
                :client-action-id="clientActionId"
                :busy="loading"
                :sentNoteFn="sentNoteFn"
                @file-sent="onSentFileFn"
                :file-url="fileUrl"
                :note-placeholder="notePlaceholder"
                :button-text="noteButtonText"
                :error-message="noteErrorMessage"
            >
            </note-modal>
            <submit-query-modal
                v-if="showSubmitQuery && showSubmitQueryModal"
                :show.sync="showSubmitQueryModal"
                :client-action-id="clientActionId"
                :type="type"
                :model="model"
                @submitted="closeActionModal"
            >
            </submit-query-modal>
            <submit-approval-modal
                :show.sync="showSubmitModal"
                :client-action-id="clientActionId"
                :type="type"
                @submitted="closeActionModal"
            >
            </submit-approval-modal>
            <escalate-query-modal
                    v-if="showEscalateQuery && showEscalateQueryModal"
                    :show.sync="showEscalateQueryModal"
                    :client-action-id="clientActionId"
                    @submitted="closeActionModal"
                    :model="model"
            >
            </escalate-query-modal>
        </div>
    </div>
</template>

<script>
import ActionStatus from '@/services/Action/ActionStatus';
import NoteModal from '@/components/Action/Modal/NoteModal';
import ClientAction from '@/services/Action/ClientAction';
import SubmitApprovalModal from '@/components/Action/Modal/SubmitForApprovalModal';
import SubmitQueryModal from '@/components/Action/Modal/SubmitQueryModal';
import api from '@/api';
import ErrorMixin from '@/components/Notifications/ErrorMixin';
import EscalateQueryModal from '@/components/Action/Modal/EscalateQueryModal';

export default {
  name: 'Client-Action-Buttons',
  components: {
    SubmitQueryModal,
    SubmitApprovalModal,
    NoteModal,
    EscalateQueryModal,
  },
  props: {
    clientAction: {
      required: true,
    },
  },
  mixins: [ErrorMixin],
  data() {
    return {
      model: ClientAction,
      noteTitle: 'Add a note',
      noteButtonText: 'Send note',
      notePlaceholder: null,
      noteErrorMessage: null,
      fileUrl: null,
      onSentFileFn: () => null,
      sentNoteFn: null,
      showNoteModal: false,
      showSubmitModal: false,
      showSubmitQueryModal: false,
      showEscalateQueryModal: false,
      loading: false,
      ready: false,
      clientActionId: null,
      type: null,
      canApprove: null,
      canReject: null,
      canSubmitQuery: null,
      canRespondToQuery: null,
      canEscalateQuery: null,
      canSubmitForApproval: null,
      status: null,
      actionButtons: [
        {
          buttonClass: '',
          variant: 'yellow',
          condition: () => this.showAddNote,
          onClick: this.onClickAddNote,
          text: 'Add note',
          icon: ['fal', 'pen-alt'],
        },
        {
          buttonClass: 'btn-arrow',
          variant: 'primary',
          condition: () => this.showNoAccess,
          onClick: this.onClickNoAccess,
          text: 'No Access',
          icon: ['far', 'arrow-right'],
        },
        {
          buttonClass: 'btn-arrow',
          variant: 'primary',
          condition: () => this.showSubmitQuery,
          onClick: this.onClickSubmitQuery,
          text: 'Submit query',
          icon: ['far', 'arrow-right'],
        },
        {
          buttonClass: 'btn-arrow',
          variant: 'primary',
          condition: () => this.showRespondToNoAccess,
          onClick: this.onClickRespondToNoAccess,
          text: 'Respond to no access',
          icon: ['far', 'arrow-right'],
        },
        {
          buttonClass: '',
          variant: 'primary',
          condition: () => this.showRespondToQuery,
          onClick: this.onClickRespondToQuery,
          text: 'Respond to query',
          icon: ['far', 'arrow-right'],
        },
        {
          buttonClass: '',
          variant: 'primary',
          condition: () => this.showEscalateQuery,
          onClick: this.onClickEscalateQuery,
          text: 'Escalate query',
          icon: ['far', 'level-up'],
        },
        {
          buttonClass: 'btn-arrow',
          variant: 'yellow',
          condition: () => this.showSubmitForApproval,
          onClick: this.onClickSubmitForApproval,
          text: 'Submit for approval',
          icon: ['far', 'arrow-right'],
        },
        {
          buttonClass: '',
          variant: 'primary',
          condition: () => this.showReject,
          onClick: this.onClickReject,
          text: 'Reject',
          icon: ['far', 'ban'],
        },
        {
          buttonClass: "",
          variant: "primary",
          condition: () => {
            return this.showReject;
          },
          onClick: this.onClickPartiallyComplete,
          text: 'Partially Complete',
          icon: ['fas', 'adjust'],
        },
        {
          buttonClass: '',
          variant: 'primary',
          condition: () => this.showApprove,
          onClick: this.onClickApprove,
          text: 'Approve',
          icon: ['fal', 'check'],
        },
      ],
    };
  },
  computed: {
    // Show / hide buttons are based on permissions and action status
    showAddNote() {
      return this.$can(this.$perm.ACTIONS_ADD_NOTE, this.$perm.PERMISSION_TYPE_ACTION);
    },
    showRespondToQuery() {
      return this.status === ActionStatus.QUERY()
        && this.$can(this.$perm.ACTIONS_RESPOND_TO_QUERY, this.$perm.PERMISSION_TYPE_ACTION)
        && this.canRespondToQuery;
    },
    showEscalateQuery() {
      return this.status === ActionStatus.QUERY()
        && this.$can(this.$perm.ACTIONS_QUERY, this.$perm.PERMISSION_TYPE_ACTION)
        && this.canEscalateQuery;
    },
    showPutOnHold() {
      return false;
    },
    showReject() {
      return this.status === ActionStatus.PENDING_APPROVAL()
          && this.$can(this.$perm.ACTIONS_REJECT, this.$perm.PERMISSION_TYPE_ACTION)
          && this.canReject;
    },
    showApprove() {
      return this.status === ActionStatus.PENDING_APPROVAL()
          && this.$can(this.$perm.ACTIONS_APPROVE, this.$perm.PERMISSION_TYPE_ACTION)
          && this.canApprove;
    },
    showNoAccess() {
      return this.status === ActionStatus.ASSIGNED();
    },
    showSubmitQuery() {
      return (this.status === ActionStatus.ASSIGNED()
          || this.status === ActionStatus.NO_ACCESS())
          && this.canSubmitQuery;
    },
    showRespondToNoAccess() {
      return this.status === ActionStatus.NO_ACCESS();
    },
    showSubmitForApproval() {
      return (this.status === ActionStatus.ASSIGNED()
          || this.status === ActionStatus.QUERY()
          || this.status === ActionStatus.NO_ACCESS())
          && this.$can(this.$perm.ACTIONS_SUBMIT_FOR_APPROVAL, this.$perm.PERMISSION_TYPE_ACTION)
            && this.canSubmitForApproval;
    },
  },
  watch: {
    clientAction: {
      handler(newClientAction) {
        this.clientActionId = newClientAction.clientActionId;
        this.type = newClientAction.type;
        this.canApprove = newClientAction.canApprove;
        this.canReject = newClientAction.canReject;
        this.canSubmitQuery = newClientAction.canSubmitQuery;
        this.canEscalateQuery = newClientAction.canEscalateQuery;
        this.canRespondToQuery = newClientAction.canRespondToQuery;
        this.canSubmitForApproval = newClientAction.canSubmitForApproval;
        this.status = newClientAction.status;
      },
      immediate: true,
    },

    loading(newLoading) {
      this.$emit('loading', newLoading);
    },
    showNoteModal(visible) {
      if (!visible) {
        this.setNoteDefaults();
      }
    },
  },
  methods: {
    setNoteDefaults() {
      this.noteTitle = 'Add a note';
      this.noteButtonText = 'Send note';
      this.notePlaceholder = null;
      this.noteErrorMessage = null;
      this.fileUrl = null;
    },

    onClickRespondToNoAccess() {
      this.showNoteModal = true;
      this.sentNoteFn = this.respondToNoAccess;
      this.noteButtonText = 'Send response';
      this.noteTitle = 'Respond to no access';
    },
    async respondToNoAccess({ note }) {
      this.loading = true;

      const params = {
        clientActionId: this.clientActionId,
        note,
      };

      try {
        await ClientAction.respondToNoAccess(params);

        const title = 'Action response submitted';
        const text = 'Response submitted to this action\'s no access.';
        const type = 'success';

        this.$notify({
          duration: 7000,
          title,
          text,
          type,
        });
        this.closeActionModal();
      } catch (e) {
        this.showErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },

    onClickRespondToQuery() {
      this.showNoteModal = true;
      this.sentNoteFn = this.respondToQuery;
      this.noteButtonText = 'Send response';
      this.noteTitle = 'Respond to query';
    },

    async respondToQuery({ note }) {
      this.loading = true;

      const params = {
        clientActionId: this.clientActionId,
        note,
      };

      try {
        await ClientAction.respondToQuery(params);

        const title = 'Action response submitted';
        const text = 'Response submitted to this action\'s query.';
        const type = 'success';

        this.$notify({
          duration: 7000,
          title,
          text,
          type,
        });
        this.closeActionModal();
      } catch (e) {
        this.showErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },

    onClickSubmitQuery() {
      this.showSubmitQueryModal = true;
    },
    onClickEscalateQuery() {
      this.showEscalateQueryModal = true;
    },
    onClickNoAccess() {
      this.showNoteModal = true;
      this.sentNoteFn = this.noAccess;
    },
    async noAccess({ note }) {
      this.loading = true;

      const params = {
        clientActionId: this.clientActionId,
        note,
      };

      try {
        await ClientAction.noAccess(params);
        this.$store.dispatch('updateActionField', { field: 'status', value: ActionStatus.NO_ACCESS() });

        const title = 'Action updated';
        const text = 'Action\'s status has been updated.';
        const type = 'success';

        this.$notify({
          duration: 7000,
          title,
          text,
          type,
        });
        this.closeActionModal();
      } catch (e) {
        this.showErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
    /**
     * Click reject
     */
    onClickReject() {
      this.showNoteModal = true;
      this.sentNoteFn = this.reject;
      this.noteButtonText = 'Confirm and reject';
      this.noteTitle = 'Reject action';
      this.notePlaceholder = 'Write a reason...';
      this.noteErrorMessage = 'Please enter a reason';
    },
    /**
     * Reject an action
     */
    async reject({ note }) {
      this.loading = true;

      const params = {
        clientActionId: this.clientActionId,
        note,
      };

      try {
        await ClientAction.reject(params);

        const title = 'Action rejected';
        const text = 'Action has been successfully rejected.';
        const type = 'success';

        this.$notify({
          duration: 7000,
          title,
          text,
          type,
        });
        this.closeActionModal();
      } catch (e) {
        this.showErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
    /**
     * Click add note
     */
    onClickAddNote() {
      this.setNoteDefaults();
      this.sentNoteFn = this.addNote;
      this.notePlaceholder = 'Write a note...';
      this.noteErrorMessage = 'Please enter a note';
      this.fileUrl = `${api.defaults.baseURL}/actions/${this.type}/${this.clientActionId}/note`;
      this.onSentFileFn = this.onSuccessfulNote;
      this.showNoteModal = true;
    },
    /**
     * Add a note against an action
     */
    async addNote({ note }) {
      this.loading = true;

      const params = {
        clientActionId: this.clientActionId,
        note,
      };
      try {
        await ClientAction.addNote(params);
        this.onSuccessfulNote();
      } catch (e) {
        this.showErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
    onSuccessfulNote() {
      const title = `Note added against #${this.clientActionId}`;
      const text = '';
      const type = 'success';

      this.$notify({
        duration: 7000,
        title,
        text,
        type,
      });
      this.closeActionModal(false);
    },
    onClickPartiallyComplete() {
      this.showNoteModal = true;
      this.sentNoteFn = this.partiallyComplete;
      this.noteButtonText = 'Partially Complete';
      this.noteTitle = 'Partially Complete Action';
      this.notePlaceholder = 'Write what has been partially completed...';
      this.noteErrorMessage = 'Please enter a message';
    },
    /**
     * Partially complete an action
     */
    async partiallyComplete({ note }) {
      this.loading = true;

      try {
        await ClientAction.partiallyComplete(this.clientActionId, note);

        const title = 'Client action partially completed';
        const type = 'success';

        this.$notify({
          duration: 7000,
          title,
          type,
        });
        this.closeActionModal();
      } catch (e) {
        this.showErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
    /**
     * Approve an action
     */
    async onClickApprove() {
      this.loading = true;
      const params = {
        clientActionId: this.clientActionId,
      };

      try {
        await ClientAction.approve(params);

        const title = 'Action approved';
        const text = 'Action has been successfully approved.';
        const type = 'success';

        this.$notify({
          duration: 7000,
          title,
          text,
          type,
        });
        this.closeActionModal();
      } catch (e) {
        this.showErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
    onClickSubmitForApproval() {
      this.showSubmitModal = true;
    },
    /**
     * Refresh actions
     * Close action modal via emit
     * Close all other modals
     */
    closeActionModal(refresh = true) {
      if (refresh) {
        this.$store.dispatch('refreshActions');
      }

      this.showNoteModal = false;
      this.showSubmitModal = false;
      this.$emit('close', true);
    },
  },
};
</script>

<style lang="scss" scoped>
    .action-buttons {
        > .btn {
            white-space: nowrap;
            &:not(:first-child) { margin-left: .25rem; }
            &:not(:last-child) { margin-right: .25rem; }
        }
    }
</style>
